import {ref,computed,reactive,defineComponent,toRefs,onMounted,nextTick} from "vue"
import TheFeedback from "@/layout/header/components/TheFeedback.vue";
import {useRouter} from "vue-router"
import { useDraggable } from '@vueuse/core'
import store from "@/store"
import { hmdConfirm } from "@/dialog/index";
export default defineComponent({
  isGlobal: true,
  name: "CustomerAssistant",
  components: {
    TheFeedback
  },
  props:{
    showAssistant:{
      type:Boolean
    }
  },
  emits:["update:showAssistant"],
  setup(props,{emit}) {
    const el = ref<HTMLElement | null>(null)
    const state = reactive({
      showTips:false,
      style:{},
      tenantUserId: computed(() => (store.state.user.userInfo as any).tenantUserId),
      key :computed(() => state.tenantUserId+"partnerone.tips")
    })
    
    const router =useRouter();
    const goZero=()=>{
      window.open("https://www.homedo.com/act/vip/v-index.shtml?from=shouye","_blank");
    }
    const goVersion=()=>{
      router.push("/version")
    }
    const goVideo=()=>{
      router.push("/novice/video-list")
    }
    const close=()=>{
      state.showTips=false;
      emit("update:showAssistant",false);
    }
    const noAlert= ()=>{
      localStorage.setItem(state.key,"1");
      close();
    }
    const closeDialog = ()=>{
      if(localStorage.getItem(state.key) ==="1"){
        emit("update:showAssistant",false)
      }else{
        state.showTips=true;
      }
    }
    const concatKefu=()=>{
      //@ts-ignore
      // const _53 = $53.createApi();
      // _53.push('cmd', 'kfclient');
      // _53.push('type', 'popup');
      // _53.query();
      // // console.log("_53",_53)
      ClinkChatWeb.openSessionWindow();
    }
    onMounted(()=>{
      // nextTick(function(){
      //   const { x, y, style } = useDraggable(el, {
      //     initialValue: { x: 400, y: 600 },
      //   });
      //   state.style = style;
      // })
    })
    const displayWX = () => {
      hmdConfirm({
        com: import("@/layout/header/components/wx.vue"),
        params: {},
        confirm: ({ res }) => {},
      });
    };
    return {
      ...toRefs(state),
      goZero,
      goVersion,
      goVideo,
      close,
      noAlert,
      closeDialog,
      concatKefu,
      el,displayWX
    }
  }
  })
